import { render } from "./TheMenu.pug?vue&type=template&id=40cf1ace&lang=pug"
import script from "./TheMenu.js?vue&type=script&lang=js"
export * from "./TheMenu.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__